var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user.plan.price === 0)?_c('div',{staticClass:"plan-upgrade-component"},[_c('hi-cell',{attrs:{"title":"Plan","type":"header"}}),_vm._v(" "),_c('div',{staticClass:"plan-type-container"},[_c('plan-pricing-package')],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65e72343","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plan/upgrade/Index.vue
// module id = null
// module chunks = 